/**
 * Compara dos datos utilizando JSON.stringify. Las funciones no se toman en cuenta.
 * @param a Dato a comparar.
 * @param b Dato a comparar.
 * @return Retorna true si ambos datos son iguales; de lo contrario, retorna false.
 */
export function compareData(a, b) {
    return JSON.stringify(a) === JSON.stringify(b)
}
